import { forwardRef } from 'react';
import { Box, Typography } from 'components';
import { StyledBreadcrumb } from './style';
import PropTypes from 'prop-types';

const Breadcrumb = forwardRef(({ content, children, bottom, ...props }, ref) => {
  return (
    <StyledBreadcrumb display="flex" bottom={bottom}>
      <Typography variant="breadcrumb">{content}</Typography>
      <Box display="flex">{children}</Box>
    </StyledBreadcrumb>
  )
});

Breadcrumb.propTypes = {
  bottom: PropTypes.number
}

Breadcrumb.defaultProps = {
  bottom: 48,
}

export default Breadcrumb;
